import React, { useEffect } from 'react';
import { TagBase } from '@milanote/roma';
import { getIsLightColor } from '../../../common/colors/coreColorUtil';

import './TagElement.scss';

type TagElementProps = {
    name: string;
    color: string;
    onClick?: () => void;
};

const TagElement: React.FC<TagElementProps> = ({ name, color, onClick }) => {
    const tagRef = React.useRef<HTMLDivElement>(null);

    // Temporary inline style approach until Roma component supports dynamic colors WEB-14790 - see also TagElement.scss
    useEffect(() => {
        tagRef.current?.style.setProperty('--tag-bg-color', color);
        tagRef.current?.style.setProperty(
            '--tag-text-color',
            getIsLightColor(color) ? 'var(--palette-grey-900)' : 'var(--palette-white)',
        );
    }, []);

    return (
        <div ref={tagRef} className="TagElement" onClick={onClick}>
            <TagBase
                size={'sm'}
                className="cursor-pointer bg-(--tag-bg-color) text-(--tag-text-color) ring-transparent rounded-[3px] max-w-full"
            >
                {name}
            </TagBase>
        </div>
    );
};

export default TagElement;
